import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// The value of props.length should always be in m so that conversions are correct
export function LengthText ({ length, longUnit, autoConvert }) {
    const lengthUnit = useSelector((state) => (state.user && state.user.prefs && state.user.prefs.defaultLengthUnit) || 'm');

    function formatLength (lengthUnit, length, longUnit, autoConvert) {
        switch (lengthUnit) {
            case 'm':
                return length > 999 && autoConvert
                    ? `${Math.max(length * 0.001, 0.01).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${longUnit ? 'kilometres' : 'km'}`
                    : `${Math.max(length, 0.01).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${longUnit ? 'metres' : 'm'}`;
            case 'km':
                return `${Math.max(length * 0.001, 0.01).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${longUnit ? 'kilometres' : 'km'}`;
            case 'ft':
                return `${Math.max(length * 10.7639, 0.01).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${longUnit ? 'foot' : 'ft'}`;
            default:
                console.error('Invalid length unit', lengthUnit);
                return `${Math.max(length, 0.01).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${longUnit ? 'metres' : 'm'}`;
        }
    }

    return (
        <span>
            {formatLength(lengthUnit, length, longUnit, autoConvert)}
        </span>
    );
}

LengthText.propTypes = {
    autoConvert: PropTypes.bool,
    length: PropTypes.number.isRequired,
    longUnit: PropTypes.bool
};

LengthText.defaultProps = {
    autoConvert: true,
    longUnit: false
};